module.exports = __webpack_public_path__ + "static/img/color3D_logo.3fc4d976.png";